<template>
  <div>
    <el-row :gutter="16">
      <el-col :span="18">
        <div class="field-container">
          <div class="title">Description</div>
          <MarkdownDisplay :value="homework.description" />
          <div class="title">Attachment</div>
          <FileDownloadCard :href="homework.attachment" />
        </div>
      </el-col>
      <el-col :span="6" style="height: 100%;">
        <div class="field-container" v-if="$store.state.userPower !== 'C'">
          <div class="title">Statistics</div>
          <HomeworkStatisticsCard
            :total="homework.student_count"
            :submitted="homework.answer_count"
            :corrected="homework.corrected_answer_count"
          />
        </div>
        <div v-else class="field-container">
          <div class="title">Score</div>
          <div v-if="homeworkSubmitted">
            <ScoreDisplay v-if="score!=null" :score="score" />
            <div class="tip-text" v-else>
              Your answer have not been graded yet.
              <br />Please wait.
            </div>
            <div class="field-button-group">
              <el-button type="primary" disabled>View Solution</el-button>
              <el-button @click="previewVisible = true">View Your Answer</el-button>
              <el-popover placement="top" width="320" v-model="popoverVisible">
                <p>Are You Sure you want to re-submit your answer?<br/>Your previous answer data will be cleared!</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="popoverVisible = false">No</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleConfirm"
                  >Yes</el-button>
                </div>
                <el-button slot="reference" type="warning" plain>Re-Submit Your Answer</el-button>
              </el-popover>
            </div>
          </div>
          <div v-else>
            <div class="tip-text">
              You have not submitted your answer yet.
              <br />Please submit the answer first.
            </div>
            <el-button @click="dialogVisible = true" type="primary">Submit Your Answer</el-button>
          </div>

          <AnswerSubmitForm
            :dialogVisible.sync="dialogVisible"
            @refresh-answer-state="refreshAnswerState"
          />
          <AnswerPreview
            :visible.sync="previewVisible"
          />
        </div>
      </el-col>
    </el-row>
    <CommentList :comments="homework.comments" @refresh-comments="refreshComments">
      <div class="input-wrapper">
        <el-input
          class="gray-bg-input"
          v-model="inputComment"
          type="textarea"
          :rows="3"
          autofocus
          placeholder="Write down your comments here..."
        ></el-input>
        <div class="btn-control">
          <el-button type="text" class="cancel" @click="cancelComment">Cancel</el-button>
          <el-button type="primary" round @click="commitComment">Commit</el-button>
        </div>
      </div>
    </CommentList>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  getHomeworkWithCommentsById,
  postHomeworkComment,
  getStudentScore
} from "@/api";
import AnswerSubmitForm from "@/components/AnswerSubmitForm.vue";
import AnswerPreview from "@/components/AnswerPreview.vue";
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import CommentList from "@/components/CommentList.vue";
import HomeworkStatisticsCard from "@/components/HomeworkStatisticsCard.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import ScoreDisplay from "@/atoms/ScoreDisplay.vue";

export default {
  name: "HomeworkDetails",
  components: {
    MarkdownDisplay,
    CommentList,
    HomeworkStatisticsCard,
    FileDownloadCard,
    AnswerSubmitForm,
    ScoreDisplay,
    AnswerPreview
  },
  data() {
    return {
      inputComment: "",
      dialogVisible: false,
      previewVisible: false,
      popoverVisible: false,

      homeworkSubmitted: false,
      score: null
    };
  },
  computed: {
    homework: function() {
      return this.$store.state.selectedHomework;
    }
  },
  mounted() {
    if (this.$store.state.userPower === "C") {
      this.refreshAnswerState();
    }
  },
  methods: {
    ...mapMutations(["setCurrentHomework"]),
    refreshAnswerState() {
      getStudentScore(this.$route.params.homework_id).then(res => {
        if (res.score !== undefined) {
          this.homeworkSubmitted = true;
          this.score = res.score;
        }
      });
    },
    refreshComments() {
      getHomeworkWithCommentsById(this.$route.params.homework_id).then(res => {
        this.setCurrentHomework(res);
      });
    },
    cancelComment() {
      this.inputComment = "";
    },
    viewAnswer() {},
    handleConfirm() {
      this.popoverVisible = false;
      this.dialogVisible = true;
    },
    commitComment() {
      const content = this.inputComment;
      const userId = this.$store.state.userId;
      const homeworkId = this.$route.params.homework_id;
      if (content && userId && homeworkId) {
        postHomeworkComment(content, homeworkId, userId).then(res => {
          if (res && res.id) {
            this.$message({
              type: "suceess",
              message: "Comment Committed!"
            });
            this.inputComment = "";
            this.refreshComments();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$text-normal: #606266;
$text-333: #333;

.field-container {
  margin: 12px 0;
  .title {
    font-size: 20px;
    margin-top: 16px;
    margin-bottom: 12px;
  }
  .score-text {
    font-size: 36px;
    font-weight: 700;
    margin: 24px auto;
  }
  .tip-text {
    color: rgba(0, 0, 0, 0.25);
    margin-bottom: 36px;
  }
  .field-button-group {
    display: flex;
    flex-direction: column;
    * {
      margin: 4px 0;
    }
    .el-button {
      width: 100%;
    }
  }
}

.input-wrapper {
  padding: 10px;
  .btn-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 10px;
    .cancel {
      font-size: 16px;
      color: $text-normal;
      margin-right: 20px;
      cursor: pointer;
      &:hover {
        color: $text-333;
      }
    }
    .confirm {
      font-size: 16px;
    }
  }
}
</style>